// frontend/src/components/technical_reports/LaudoTensaoAplicada.js
import React, { useState, useEffect } from 'react';

// --- IMPORTANTE: SALVE SUAS IMAGENS NA MESMA PASTA DO ARQUIVO JS ---
import logoLaudoDefault from './logo_laudo.png';
import assinaturaTecnico from './assinatura_tecnico.png';

// --- MAPA DE TRADUÇÃO DE ITENS TÉCNICOS ---
const ITEM_TRANSLATIONS = {
    "CESTO AÉREO": { pt: "CESTO AÉREO", en: "INSULATED AERIAL BASKET", es: "CESTA AÉREA" },
    "CESTA AÉREA ISOLADA": { pt: "CESTA AÉREA ISOLADA", en: "INSULATED AERIAL BASKET", es: "CESTA AÉREA AISLADA" },
    "LANÇA ISOLADA": { pt: "LANÇA ISOLADA", en: "ISOLATED LANCE", es: "LANZA AISLADA" },
    "LINER": { pt: "LINER", en: "LINER", es: "LINER" },
    "ATERRAMENTO TEMPORÁRIO BT": { pt: "ATERRAMENTO TEMPORÁRIO BT", en: "TEMPORARY GROUNDING LV", es: "PUESTA A TIERRA TEMPORAL BT" },
    "ATERRAMENTO TEMPORÁRIO MT": { pt: "ATERRAMENTO TEMPORÁRIO MT", en: "TEMPORARY GROUNDING MV", es: "PUESTA A TIERRA TEMPORAL MT" },
    "ATERRAMENTO TEMPORÁRIO AT": { pt: "ATERRAMENTO TEMPORÁRIO AT", en: "TEMPORARY GROUNDING HV", es: "PUESTA A TIERRA TEMPORAL AT" },
    "ESCADAS ISOLADAS": { pt: "ESCADAS ISOLADAS", en: "INSULATED LADDERS", es: "ESCALERAS AISLADAS" },
    "VARA DE MANOBRA": { pt: "VARA DE MANOBRA", en: "HOT STICK", es: "PÉRTIGA DE MANIOBRA" },
    "BANQUETA ISOLADA": { pt: "BANQUETA ISOLADA", en: "INSULATED PLATFORM", es: "BANQUETA AISLADA" }
};

// --- TRADUÇÃO DO TÍTULO DAS FOTOS ---
const PHOTO_TITLES = {
    pt: "LAUDO FOTOGRÁFICO",
    en: "PHOTOGRAPHIC REPORT",
    es: "REPORTE FOTOGRÁFICO"
};

// --- TEMPLATES DE FRASES ---
const SPECIAL_ITEMS_TEMPLATES = {
    "CESTO AÉREO": {
        pt: { scope: "Ensaio em cesto aéreo isolado conforme norma {NORM}", headerTitle: "ENSAIO EM CESTO AÉREO ISOLADO", defaultAnsi: "" },
        en: { scope: "Test on Insulated Aerial Basket according to standard {NORM}", headerTitle: "TEST ON INSULATED AERIAL BASKET", defaultAnsi: "ANSI 92-2 - 2021" },
        es: { scope: "Ensayo em Canasta Aérea Aislada conforme la norma {NORM}", headerTitle: "ENSAYO EN CANASTA AÉREA AISLADA", defaultAnsi: "ANSI 92-2 - 2021" }
    },
    "CESTA AÉREA ISOLADA": { 
        pt: { scope: "Ensaio em cesta aérea isolada conforme norma {NORM}", headerTitle: "ENSAIO EM CESTA AÉREA ISOLADA", defaultAnsi: "" },
        en: { scope: "Test on Insulated Aerial Basket according to standard {NORM}", headerTitle: "TEST ON INSULATED AERIAL BASKET", defaultAnsi: "ANSI 92-2 - 2021" },
        es: { scope: "Ensayo em Canasta Aérea Aislada conforme la norma {NORM}", headerTitle: "ENSAYO EN CANASTA AÉREA AISLADA", defaultAnsi: "ANSI 92-2 - 2021" }
    },
    "LANÇA ISOLADA": {
        pt: { scope: "Ensaio em lança isolada conforme norma {NORM}", headerTitle: "ENSAIO EM LANÇA ISOLADA", defaultAnsi: "" },
        en: { scope: "Test on isolated lance according to standard {NORM}", headerTitle: "TEST ON ISOLATED LANCE", defaultAnsi: "ANSI 92-2 - 2021" },
        es: { scope: "Ensayo em lanza aislada conforme la norma {NORM}", headerTitle: "ENSAYO EN LANZA AISLADA", defaultAnsi: "ANSI 92-2 - 2021" }
    }
};

// --- DICIONÁRIO DE TRADUÇÕES GERAIS ---
const TRANSLATIONS = {
  pt: {
    title: "ENSAIO ELÉTRICO DE TENSÃO APLICADA",
    ref: "REFERÊNCIA:", cat: "CATEGORIA: C", emission: "EMISSÃO:", state_reg: "Inscrição Estadual:",
    phone_label: "Telefone:", email_label: "E-mail:", h_test: "ENSAIO:", h_norm: "NORMA:",
    h_total: "TOTAL:", h_approved: "APROVADO:", h_repro: "REPROVADO:", item_cesta: "CESTA AÉREA ISOLADA",
    item_liner: "LINER", sec_1: "1- OBJETO / ESCOPO", text_test_in: "Ensaio em", text_according: "conforme norma",
    lanca_sup: "- LANÇA SUPERIOR", iso_chassi: "- ISOLAMENTO DE CHASSI", liner: "- LINER",
    sec_2: "2 - DADOS DO CLIENTE", client: "CLIENTE:", cnpj: "CNPJ:", manager: "GESTOR:", phone: "TELEFONE:",
    sec_3: "3 - ÁREA ATENDIDA", local: "CLIENTE:", 
    sec_4: "4 - CARACTERÍSTICAS DO VEÍCULO OPERACIONAL", brand: "MARCA:", model: "MODELO:", chassi: "CHASSI:",
    plate: "PLACA:", odo: "HODÔMETRO:", hori: "HORÍMETRO:",
    sec_5: "5 - CARACTERÍSTICAS DA LANÇA ISOLADA", serial: "NÚMERO DE SÉRIE:", baskets: "CESTOS:",
    capacity: "CAPACIDADE:", category: "CATEGORIA:", class: "CLASSE DE TENSÃO:", stab: "ESTABILIZADOR:", type_test: "TIPO ENSAIO:",
    sec_6: "6 - INSTRUMENTAÇÃO", mod_serial: "MODELO / Nº SÉRIE:", cert: "CERTIFICADO DO LAUDO DE CALIBRAÇÃO:", validity: "VALIDADE:",
    sec_7: "7 - DADOS DO ENSAIO (LANÇA)", city: "CIDADE:", date: "DATA:", temp: "TEMP. (MÉDIA):", lot: "LOTE:",
    h_start: "HORA INÍCIO:", h_end: "HORA FIM:", humid: "UMIDADE REL.:", trace: "RASTREABILIDADE:",
    sec_8: "8 - VALORES DE CORRENTE DE FUGA MENSURADOS", qualif_test: "ENSAIO DE QUALIFICAÇÃO", period_test: "ENSAIO PERIÓDICO",
    liner_test_title: "ENSAIO DIELÉTRICO DO LINER", qualif: "QUALIFICAÇÃO", period: "PERIÓDICO",
    col_voltage: "TENSÃO", col_leak: "FUGA MÁX", col_measure: "MEDIÇÃO", col_time: "TEMPO", col_result: "RESULTADO",
    col_applied: "APLICADO", col_method: "MÉTODO", obs: "OBSERVAÇÕES RELEVANTES:",
    sec_9: "9 - DADOS DO ENSAIO ( LINER )", v_plate: "PLACA VEÍCULO:", v_chassi: "CHASSI VEÍCULO:",
    sec_10: "10 - ATENÇÃO", valid_until: "VÁLIDO ATÉ",
    warning_msg: "ESTE EQUIPAMENTO DEVERÁ SER ENSAIADO NOVAMENTE NO PRAZO MÁXIMO DE 12 MESES OU QUANDO HOUVER QUALQUER SUSPEITA PARTE DO USUÁRIO",
    engineer_title: "Engenheiro Eletricista",
    sec_10_resp: "10 - RESPONSABILIDADE", emission_sign: "EMISSÃO:", approval_sign: "APROVAÇÃO:", tech_default: "Técnico Responsável", reg_default: "Registro",
    defaults: { applied_no: "NÃO", method_liquid: "Liquido\nCondutivo", method_liquid_dry: "Liquido Condutivo\nou a seco com\neletrodos condutores", obs_text: "Após a realização do Ensaio, comprova-se que não há perfurações no LINER para APROVAÇÃO." }
  },
  en: {
    title: "APPLIED VOLTAGE ELECTRICAL TEST", ref: "REFERENCE:", cat: "CATEGORY: C", emission: "ISSUE DATE:", state_reg: "State Reg:",
    phone_label: "Phone:", email_label: "E-mail:", h_test: "TEST:", h_norm: "STANDARD:", h_total: "TOTAL:", h_approved: "APPROVED:", h_repro: "FAILED:",
    item_cesta: "INSULATED AERIAL BASKET", item_liner: "LINER", sec_1: "1- OBJECT / SCOPE", text_test_in: "Test on", text_according: "according to standard",
    lanca_sup: "- UPPER BOOM", iso_chassi: "- CHASSIS ISOLATION", liner: "- LINER",
    sec_2: "2 - CLIENT DATA", client: "CLIENT:", cnpj: "TAX ID:", manager: "MANAGER:", phone: "PHONE:",
    sec_3: "3 - SERVICE AREA", local: "CLIENT:", 
    sec_4: "4 - OPERATIONAL VEHICLE CHARACTERISTICS", brand: "MAKE:", model: "MODEL:", chassi: "VIN:", plate: "LICENSE PLATE:", odo: "ODOMETER:", hori: "HOUR METER:",
    sec_5: "5 - INSULATED BOOM CHARACTERISTICS", serial: "SERIAL NUMBER:", baskets: "BASKETS:", capacity: "CAPACITY:", category: "CATEGORY:", class: "VOLTAGE CLASS:", stab: "STABILIZER:", type_test: "TEST TYPE:",
    sec_6: "6 - INSTRUMENTATION", mod_serial: "MODEL / SERIAL NO.:", cert: "CALIBRATION CERTIFICATE:", validity: "VALIDITY:",
    sec_7: "7 - TEST DATA (BOOM)", city: "CITY:", date: "DATE:", temp: "TEMP. (AVG):", lot: "BATCH:", h_start: "START TIME:", h_end: "END TIME:", humid: "REL. HUMIDITY:", trace: "TRACEABILITY:",
    sec_8: "8 - MEASURED LEAKAGE CURRENT VALUES", qualif_test: "QUALIFICATION TEST", period_test: "PERIODIC TEST", liner_test_title: "LINER DIELECTRIC TEST", qualif: "QUALIFICATION", period: "PERIODIC",
    col_voltage: "VOLTAGE", col_leak: "MAX LEAK", col_measure: "MEASURE", col_time: "TIME", col_result: "RESULT", col_applied: "APPLIED", col_method: "METHOD", obs: "RELEVANT OBSERVATIONS:",
    sec_9: "9 - TEST DATA ( LINER )", v_plate: "VEHICLE PLATE:", v_chassi: "VEHICLE VIN:",
    sec_10: "10 - ATTENTION", valid_until: "VALID UNTIL", warning_msg: "THIS EQUIPMENT MUST BE TESTED AGAIN WITHIN A MAXIMUM PERIOD OF 12 MONTHS",
    engineer_title: "Electrical Engineer",
    sec_10_resp: "10 - RESPONSIBILITY", emission_sign: "ISSUED BY:", approval_sign: "APPROVED BY:", tech_default: "Responsible Technician", reg_default: "Registry",
    defaults: { applied_no: "NO", method_liquid: "Conductive\nLiquid", method_liquid_dry: "Conductive Liquid\nor dry with\nconductive electrodes", obs_text: "After testing, it is verified that there are no perforations in the LINER for APPROVAL." }
  },
  es: {
    title: "ENSAYO ELÉCTRICO DE TENSIÓN APLICADA", ref: "REFERENCIA:", cat: "CATEGORÍA: C", emission: "EMISIÓN:", state_reg: "Reg. Estatal:",
    phone_label: "Teléfono:", email_label: "E-mail:", h_test: "ENSAYO:", h_norm: "NORMA:", h_total: "TOTAL:", h_approved: "APROBADO:", h_repro: "REPROBADO:",
    item_cesta: "CESTA AÉREA AISLADA", item_liner: "LINER", sec_1: "1- OBJETO / ALCANCE", text_test_in: "Ensayo en", text_according: "según norma",
    lanca_sup: "- BRAZO SUPERIOR", iso_chassi: "- AISLAMIENTO DE CHASIS", liner: "- LINER",
    sec_2: "2 - DATOS DEL CLIENTE", client: "CLIENTE:", cnpj: "RUC/NIT:", manager: "GESTOR:", phone: "TELÉFONO:",
    sec_3: "3 - ÁREA ATENDIDA", local: "CLIENTE:", 
    sec_4: "4 - CARACTERÍSTICAS DO VEÍCULO OPERATIVO", brand: "MARCA:", model: "MODELO:", chassi: "CHASIS:", plate: "PLACA:", odo: "ODÓMETRO:", hori: "HORÓMETRO:",
    sec_5: "5 - CARACTERÍSTICAS DEL BRAZO AISLADO", serial: "NÚMERO DE SÉRIE:", baskets: "CESTOS:", capacity: "CAPACIDAD:", category: "CATEGORÍA:", class: "CLASE DE TENSIÓN:", stab: "ESTABILIZADOR:", type_test: "TIPO ENSAYO:",
    sec_6: "6 - INSTRUMENTAÇÃO", mod_serial: "MODELO / Nº SERIE:", cert: "CERTIFICADO DE CALIBRACIÓN:", validity: "VALIDEZ:",
    sec_7: "7 - DATOS DEL ENSAYO (BRAZO)", city: "CIUDAD:", date: "FECHA:", temp: "TEMP. (MEDIA):", lot: "LOTE:", h_start: "HORA INICIO:", h_end: "HORA FIN:", humid: "HUMEDAD REL.:", trace: "TRAZABILIDAD:",
    sec_8: "8 - VALORES DE CORRENTE DE FUGA MEDIDOS", qualif_test: "ENSAYO DE CUALIFICACIÓN", period_test: "ENSAYO PERIÓDICO", liner_test_title: "ENSAYO DIELÉCTRICO DEL LINER", qualif: "CUALIFICACIÓN", period: "PERIÓDICO",
    col_voltage: "TENSIÓN", col_leak: "FUGA MÁX", col_measure: "MEDICIÓN", col_time: "TIEMPO", col_result: "RESULTADO", col_applied: "APLICADO", col_method: "MÉTODO", obs: "OBSERVAÇÕES RELEVANTES:",
    sec_9: "9 - DATOS DEL ENSAYO ( LINER )", v_plate: "PLACA VEHÍCULO:", v_chassi: "CHASIS VEHÍCULO:",
    sec_10: "10 - ATENÇÃO", valid_until: "VÁLIDO HASTA", warning_msg: "ESTE EQUIPO DEBE SER ENSAYADO NUEVAMENTE EN UN PLAZO MÁXIMO DE 12 MESES",
    engineer_title: "Ingeniero Electricista",
    sec_10_resp: "10 - RESPONSABILIDADE", emission_sign: "EMISIÓN:", approval_sign: "APROVACIÓN:", tech_default: "Técnico Responsável", reg_default: "Registro",
    defaults: { applied_no: "NO", method_liquid: "Líquido\nConductivo", method_liquid_dry: "Líquido Conductivo\no en seco com\neletrodos conductores", obs_text: "Después de la prueba, se verifica que no hay perforaciones en el LINER para APROBACIÓN." }
  }
};

// --- HELPER DE DATA ---
const getTodayLocalISO = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// --- HELPER DE CÁLCULO DE VALIDADE ---
const calculateExpiration = (emissionDate, months) => {
    if (!emissionDate) return '';
    const d = new Date(emissionDate + 'T00:00:00'); // Força hora zerada para evitar fuso
    if (isNaN(d.getTime())) return '';
    d.setMonth(d.getMonth() + parseInt(months));
    return d.toISOString().split('T')[0];
};

// --- HELPER DE IMAGEM (CORRIGIDO PARA DRIVE E IMPRESSÃO) ---
const getDirectImageUrl = (url) => {
    if (!url) return '';
    if (url.match(/\.(jpeg|jpg|gif|png)$/) != null) return url; 
    
    // Expressão regular aprimorada para capturar o ID do Drive de várias formas comuns
    const idMatch = url.match(/(?:drive\.google\.com\/(?:file\/d\/|open\?id=)|docs\.google\.com\/uc\?id=)([a-zA-Z0-9_-]+)/);
    
    if (idMatch && idMatch[1]) {
        // O endpoint 'thumbnail' com parâmetro de tamanho (sz=w1000) burla o bloqueio de CORS do Drive
        return `https://drive.google.com/thumbnail?id=${idMatch[1]}&sz=w1000`;
    }
    return url;
};

// --- FUNÇÃO AUXILIAR DE FORMATAÇÃO (Sentence Case) ---
const formatSentenceCase = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// --- COMPONENTES AUXILIARES ---

const InputCell = ({ field, data, onChange, readOnly, type = 'text', align = 'center', style = {}, placeholder = '', valueOverride }) => (
  <input
    type={type}
    value={valueOverride !== undefined ? valueOverride : (data[field] || '')}
    onChange={(e) => !readOnly && onChange(field, e.target.value)}
    disabled={readOnly}
    placeholder={placeholder}
    className="print-input"
    style={{
      width: '100%', height: '100%', border: 'none', background: readOnly ? 'transparent' : 'rgba(0, 123, 255, 0.1)',
      fontFamily: 'Calibri, Arial, sans-serif', fontSize: '7.5px', color: '#00008B', fontWeight: 'bold',
      textAlign: align, outline: 'none', boxSizing: 'border-box', padding: '0 2px', ...style
    }}
  />
);

const TextAreaCell = ({ field, data, onChange, readOnly, align = 'center', style = {} }) => (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <textarea
        value={data[field] || ''}
        onChange={(e) => !readOnly && onChange(field, e.target.value)}
        disabled={readOnly}
        className="print-input"
        style={{
            width: '100%', height: '100%', minHeight: '45px', border: 'none', background: readOnly ? 'transparent' : 'rgba(0, 123, 255, 0.1)',
            fontFamily: 'Calibri, Arial, sans-serif', fontSize: '7.5px', color: '#00008B', fontWeight: 'bold',
            textAlign: align, outline: 'none', boxSizing: 'border-box', resize: 'none', overflow: 'hidden',
            padding: '2px', lineHeight: '1.1', whiteSpace: 'pre-wrap', ...style
        }}
        />
    </div>
);

// --- NOVO COMPONENTE: RESULTADO (Dropdown) ---
const ResultSelectCell = ({ field, data, onChange, readOnly }) => {
    const value = data[field] || 'N/A'; // Default para N/A

    // Define cor baseado no valor
    let color = '#00008B'; // Azul padrão (N/A)
    if (value === 'APROVADO') color = '#008000'; // Verde
    if (value === 'REPROVADO') color = '#FF0000'; // Vermelho

    return (
        <select
            value={value}
            onChange={(e) => !readOnly && onChange(field, e.target.value)}
            disabled={readOnly}
            className="print-input"
            style={{
                width: '100%', height: '100%', border: 'none', background: readOnly ? 'transparent' : 'rgba(0, 123, 255, 0.1)',
                fontFamily: 'Calibri, Arial, sans-serif', fontSize: '7.5px', fontWeight: 'bold',
                color: color, textAlign: 'center', outline: 'none', appearance: 'none', WebkitAppearance: 'none',
                textAlignLast: 'center'
            }}
        >
            <option value="N/A" style={{color: 'blue'}}>N/A</option>
            <option value="APROVADO" style={{color: 'green'}}>APROVADO</option>
            <option value="REPROVADO" style={{color: 'red'}}>REPROVADO</option>
        </select>
    );
};

const CheckCell = ({ field, label, data, onChange, readOnly }) => {
  const isChecked = !!data[field];
  return (
    <span 
      style={{ cursor: readOnly ? 'default' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
      onClick={() => !readOnly && onChange(field, !isChecked)}
    >
      ({isChecked ? ' X ' : '\u00A0\u00A0\u00A0'}) {label}
    </span>
  );
};

// --- COMPONENTE PRINCIPAL ---
const LaudoTensaoAplicada = ({ data = {}, onChange, readOnly = false, availableTrucks = [], onTruckSelect, photos = [], currentUser }) => {
  const safeData = data || {};
  const lang = safeData.language || 'pt';
  const t = TRANSLATIONS[lang] || TRANSLATIONS.pt;

  // --- ESTADOS ---
  const [availableSignatures, setAvailableSignatures] = useState([]);
  const [reportLayout, setReportLayout] = useState({});

  // --- EFEITO: BUSCAR CONFIGURAÇÕES E ASSINATURAS ---
  useEffect(() => {
      const initializeLaudo = async () => {
          let initialUpdates = {};
          let hasUpdates = false;

          const token = localStorage.getItem('token');

          // --- DECODIFICA O TOKEN PARA DESCOBRIR O ID DO USUÁRIO LOGADO ---
          let currentUserId = currentUser?.id || null;
          if (!currentUserId && token) {
              try {
                  const base64Url = token.split('.')[1];
                  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                  }).join(''));
                  const payload = JSON.parse(jsonPayload);
                  currentUserId = payload.id;
              } catch (e) {
                  console.error("Erro ao decodificar token", e);
              }
          }

          // 1. Busca as assinaturas disponíveis
          try {
              const sigResponse = await fetch('/api/users/signatures/available', {
                  headers: { 'Authorization': `Bearer ${token}` }
              });
              if (sigResponse.ok) {
                  const signaturesFetched = await sigResponse.json();
                  setAvailableSignatures(signaturesFetched);

                  // Filtros
                  const techsOnly = signaturesFetched.filter(s => s.is_responsible_engineer != 1 && s.is_responsible_engineer !== true && s.is_responsible_engineer !== '1');
                  const engsOnly = signaturesFetched.filter(s => s.is_responsible_engineer == 1 || s.is_responsible_engineer === true || s.is_responsible_engineer === '1');

                  // Verifica se é um laudo NOVO (em branco)
                  const isNewReport = !safeData.padrao_modelo_serie;

                  // --- PREENCHIMENTO AUTOMÁTICO (APENAS PARA LAUDOS NOVOS / SEM ASSINATURA) ---
                  if (!safeData.tecnico_assinatura_id && isNewReport) {
                      // Tenta achar a assinatura do usuário logado
                      const myTechSig = techsOnly.find(s => String(s.id) === String(currentUserId));
                      if (myTechSig) {
                          initialUpdates.tecnico_assinatura_id = String(myTechSig.id);
                          hasUpdates = true;
                      } 
                  }

                  if (!safeData.engenheiro_assinatura_id && isNewReport) {
                      // Tenta achar a assinatura do usuário logado (se ele for o engenheiro)
                      const myEngSig = engsOnly.find(s => String(s.id) === String(currentUserId));
                      if (myEngSig) {
                          initialUpdates.engenheiro_assinatura_id = String(myEngSig.id);
                          hasUpdates = true;
                      } 
                  }
              }
          } catch (e) { 
              console.error("Erro ao buscar assinaturas:", e); 
          }

          // 2. Busca o Layout do Laudo (DA ROTA REPORTLAYOUT.JS)
          try {
              const layoutResponse = await fetch('/api/report-layout-settings', {
                  headers: { 'Authorization': `Bearer ${token}` }
              });
              if (layoutResponse.ok) {
                  const layoutData = await layoutResponse.json();
                  setReportLayout(layoutData);
              }
          } catch (e) {
              console.error("Erro ao buscar layout do laudo:", e);
          }

          if (readOnly) return; 

          // 3. Prepara os dados padrões se estiverem vazios
          if (!safeData.data_emissao) {
              initialUpdates.data_emissao = getTodayLocalISO();
              hasUpdates = true;
          }

          if (!safeData.cliente_cnpj && safeData.cnpj_automatico) {
              initialUpdates.cliente_cnpj = safeData.cnpj_automatico;
              hasUpdates = true;
          }

          const currentDefaults = t.defaults; 
          const defaultValues = {
              padrao_modelo_serie: 'HIPOT 120KV 100mA AC - IN 426072-33319',
              padrao_certificado: '8756/2026',
              padrao_validade: '2027-03-10',
              lanca_qualif_tensao: '100 KV',
              lanca_qualif_corrente: '1000 µA (1 mA)',
              lanca_qualif_medicao: 'µA',
              lanca_qualif_tempo: '3 MIN',
              lanca_qualif_resultado: 'N/A',
              chassi_qualif_tensao: '50 KV',
              chassi_qualif_corrente: '3000 µA (3mA)',
              chassi_qualif_tempo: '3 MIN',
              chassi_qualif_resultado: 'N/A',
              lanca_period_tensao: '40 KV',
              lanca_period_corrente: '400 µA (0,4 mA)',
              lanca_period_tempo: '3 MIN',
              lanca_period_resultado: 'N/A',
              chassi_period_tensao: '35 KV',
              chassi_period_corrente: '3000 µA (3mA)',
              chassi_period_tempo: '3 MIN',
              chassi_period_resultado: 'N/A',
              liner_qualif_aplicado: currentDefaults.applied_no,
              liner_qualif_tensao: '50 Kv',
              liner_qualif_tempo: '3 Min',
              liner_qualif_metodo: currentDefaults.method_liquid,
              liner_qualif_resultado: 'N/A',
              liner_period_aplicado: currentDefaults.applied_no,
              liner_period_tensao: '35 Kv',
              liner_period_tempo: '3 Min',
              liner_period_metodo: currentDefaults.method_liquid_dry,
              liner_period_res: 'N/A',
              obs_relevantes: currentDefaults.obs_text
          };

          Object.entries(defaultValues).forEach(([key, value]) => {
              if (!safeData[key]) {
                  initialUpdates[key] = value;
                  hasUpdates = true;
              }
          });

          // 4. Dispara a atualização em um lote único
          if (hasUpdates) {
              onChange({ ...safeData, ...initialUpdates });
          }
      };

      initializeLaudo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Função interna para atualizar múltiplos campos
  const updateData = (updates) => {
      if (readOnly) return;
      onChange({ ...safeData, ...updates });
  };

  // Função genérica de mudança
  const handleChange = (field, value) => {
    if (field === 'data_emissao') {
        const item = availableTrucks.find(t => t.descricao === safeData.item_servico_selecionado);
        const validity = item?.service_table?.validity_months || item?.validity_months || 12; // Default 12 meses
        const newValidity = calculateExpiration(value, validity);
        updateData({ [field]: value, data_validade: newValidity });
    } else {
        updateData({ [field]: value });
    }
  };

  // Lógica de mudança do dropdown de assinatura do Técnico
  const handleChangeSignatureInternal = (sigId) => {
      updateData({ tecnico_assinatura_id: sigId });
  };

  // Lógica de mudança do dropdown de assinatura do Engenheiro
  const handleChangeEngineerSignatureInternal = (sigId) => {
      updateData({ engenheiro_assinatura_id: sigId });
  };

  const handleSignatureSelection = (e) => {
      handleChangeSignatureInternal(e.target.value);
  };

  const handleEngineerSelection = (e) => {
      handleChangeEngineerSignatureInternal(e.target.value);
  };

  const handleSelectionChange = (e) => {
      const selectedName = e.target.value;
      const selectedItem = availableTrucks.find(t => t.descricao === selectedName);
      
      let updates = {
          item_servico_selecionado: selectedName
      };

      if (selectedItem) {
          updates.titulo_ensaio_nome = selectedItem.descricao;
          updates.titulo_ensaio_norma = selectedItem.applied_standards;
          
          let ansi = '';
          if (selectedItem.service_table && selectedItem.service_table.ansi_standards) {
              ansi = selectedItem.service_table.ansi_standards;
          } else if (selectedItem.ansi_standards) {
              ansi = selectedItem.ansi_standards;
          }
          updates.norma_ansi = ansi;

          const validity = selectedItem.service_table?.validity_months || selectedItem.validity_months || 12; 
          const emission = safeData.data_emissao || getTodayLocalISO();
          updates.data_validade = calculateExpiration(emission, validity);

      } else {
          updates.titulo_ensaio_nome = '';
          updates.titulo_ensaio_norma = '';
          updates.norma_ansi = '';
          updates.data_validade = '';
      }

      updateData(updates);

      if (onTruckSelect) {
          onTruckSelect(selectedName);
      }
  };

  const getTranslatedItem = (itemName) => {
      if (!itemName) return '';
      const upperName = itemName.toUpperCase().trim();
      let foundKey = null;
      for (const [key, translations] of Object.entries(ITEM_TRANSLATIONS)) {
          if (Object.values(translations).map(v => v.toUpperCase()).includes(upperName)) {
              foundKey = key;
              break;
          }
      }
      if (foundKey && ITEM_TRANSLATIONS[foundKey][lang]) {
          return ITEM_TRANSLATIONS[foundKey][lang];
      }
      return itemName;
  };

  const getFormattedNorm = (fallbackAnsi = null) => {
      const standardNorm = safeData.titulo_ensaio_norma || '';
      const ansiNorm = safeData.norma_ansi || fallbackAnsi || '';
      
      if ((lang === 'en' || lang === 'es') && ansiNorm) {
          return `${standardNorm} / ${ansiNorm}`;
      }
      return standardNorm;
  };

  const getScopeText = () => {
      const itemName = safeData.titulo_ensaio_nome;
      if (!itemName) return "Texto dinâmico";
      const upperName = itemName.toUpperCase().trim();
      let foundKey = null;
      for (const [key, translations] of Object.entries(SPECIAL_ITEMS_TEMPLATES)) {
          const normalizedKey = key.toUpperCase();
          if (normalizedKey === upperName || Object.values(translations).some(v => v && v.scope && v.scope.toUpperCase().includes(upperName))) {
              foundKey = key;
              break;
          }
      }
      if (foundKey && SPECIAL_ITEMS_TEMPLATES[foundKey][lang]) {
          const template = SPECIAL_ITEMS_TEMPLATES[foundKey][lang];
          const finalNorm = getFormattedNorm(template.defaultAnsi);
          return template.scope.replace('{NORM}', finalNorm);
      }
      return "Texto dinâmico";
  };

  const scopeText = getScopeText();

  const getSpecialData = () => {
      const itemName = safeData.titulo_ensaio_nome;
      if (!itemName) return null;
      const upperName = itemName.toUpperCase().trim();
      let foundKey = null;
      for (const [key, translations] of Object.entries(SPECIAL_ITEMS_TEMPLATES)) {
          const normalizedKey = key.toUpperCase();
          if (normalizedKey === upperName || 
             (Object.values(translations).some(langData => langData.headerTitle && langData.headerTitle.toUpperCase().includes(upperName)))) {
              foundKey = key;
              break;
          }
      }
      if (foundKey && SPECIAL_ITEMS_TEMPLATES[foundKey][lang]) {
          const template = SPECIAL_ITEMS_TEMPLATES[foundKey][lang];
          return {
              headerTitle: template.headerTitle,
              headerNorm: getFormattedNorm(template.defaultAnsi)
          };
      }
      return null;
  };

  const specialData = getSpecialData();

  const translateRole = (roleText) => {
      if (!roleText) return t.tech_default;
      const upper = roleText.toUpperCase();
      if (lang === 'en') {
          if (upper.includes('TÉCNICO EM ELETROTÉCNICA') || upper.includes('TECNICO EM ELETROTECNICA')) return 'Electrotechnical Technician';
          if (upper.includes('TÉCNICO') || upper.includes('TECNICO')) return 'Technician';
      }
      if (lang === 'es') {
          if (upper.includes('TÉCNICO EM ELETROTÉCNICA') || upper.includes('TECNICO EM ELETROTECNICA')) return 'Técnico en Electrotecnia';
          if (upper.includes('TÉCNICO') || upper.includes('TECNICO')) return 'Técnico';
      }
      return roleText; 
  };

  const commonProps = {
    data: safeData,
    onChange: handleChange,
    readOnly: readOnly
  };

  const validPhotos = photos ? photos.filter(p => p && p.trim() !== '') : [];

  // --- RENDERIZAÇÃO DAS ASSINATURAS (CRUZANDO ID DO BANCO COM DADOS ATUAIS DA API) ---
  const engSignatureObj = availableSignatures.find(s => String(s.id) === String(safeData.engenheiro_assinatura_id));
  const techSignatureObj = availableSignatures.find(s => String(s.id) === String(safeData.tecnico_assinatura_id));

  // Se encontrou o usuário na API, usa os dados dele (assim sempre fica atualizado se ele mudar a foto/nome no perfil).
  // Se não encontrou, usa o que tá gravado no JSON (safeData). Se não tiver nada, fica vazio.
  const finalEngImagemRaw = engSignatureObj?.signature_image_path || safeData.engenheiro_imagem || '';
  const finalEngNome = engSignatureObj?.signature_name || safeData.engenheiro_nome || '';
  const finalEngFuncao = engSignatureObj?.signature_role || safeData.engenheiro_funcao || '';
  const finalEngRegistro = engSignatureObj?.signature_registry || safeData.engenheiro_registro || '';

  const finalTechImagemRaw = techSignatureObj?.signature_image_path || safeData.tecnico_imagem || '';
  const finalTechNome = techSignatureObj?.signature_name || safeData.tecnico_nome || '';
  const finalTechFuncao = techSignatureObj?.signature_role || safeData.tecnico_funcao || '';
  const finalTechRegistro = techSignatureObj?.signature_registry || safeData.tecnico_registro || '';

  // Applica a função Helper na imagem para garantir que o html2canvas consegue processar o caminho
  const finalEngImagem = finalEngImagemRaw ? getDirectImageUrl(finalEngImagemRaw) : '';
  const finalTechImagem = finalTechImagemRaw ? getDirectImageUrl(finalTechImagemRaw) : '';

  return (
    <div className="laudo-container-outer no-print-bg" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div className="laudo-container">
        
        {!readOnly && (
          <div className="no-print" style={{ 
              marginBottom: '15px', 
              padding: '10px', 
              backgroundColor: safeData.item_servico_selecionado ? '#f0f9ff' : '#fff0f0', 
              border: safeData.item_servico_selecionado ? '1px solid #bae6fd' : '1px solid #feb2b2',
              borderRadius: '5px' 
          }}>
              <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', color: '#0369a1' }}>
                  Vincular Item da OS (Caminhão/Cesta): <span style={{color: 'red'}}>*</span>
              </label>
              <select
                  value={safeData.item_servico_selecionado || ''}
                  onChange={handleSelectionChange} 
                  style={{ 
                      width: '100%', 
                      padding: '8px', 
                      borderRadius: '4px', 
                      border: safeData.item_servico_selecionado ? '1px solid #ccc' : '2px solid red'
                  }}
              >
                  <option value="">-- Selecione um item da OS (Obrigatório) --</option>
                  {availableTrucks.map((truck, idx) => (
                      <option key={idx} value={truck.descricao}>
                          {truck.descricao}
                      </option>
                  ))}
              </select>
              {!safeData.item_servico_selecionado && (
                  <div style={{ color: 'red', fontSize: '12px', marginTop: '5px', fontWeight: 'bold' }}>
                      ⚠ É obrigatório selecionar um item para gerar o laudo corretamente.
                  </div>
              )}
              
              <div style={{ marginTop: '15px', borderTop: '1px dashed #ccc', paddingTop: '10px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                  <div>
                      <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', color: '#0369a1' }}>
                          Responsável Técnico (Emissão):
                      </label>
                      <select
                          value={safeData.tecnico_assinatura_id || ''}
                          onChange={handleSignatureSelection} 
                          style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                      >
                          <option value="">-- Assinatura Padrão / Em Branco --</option>
                          {availableSignatures.filter(s => s.is_responsible_engineer != 1 && s.is_responsible_engineer !== true && s.is_responsible_engineer !== '1').map((sig, idx) => (
                              <option key={idx} value={sig.id}>
                                  {sig.signature_name} - {sig.signature_role}
                              </option>
                          ))}
                      </select>
                  </div>

                  <div>
                      <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', color: '#0369a1' }}>
                          Engenheiro Responsável (Aprovação):
                      </label>
                      <select
                          value={safeData.engenheiro_assinatura_id || ''}
                          onChange={handleEngineerSelection} 
                          style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                      >
                          <option value="">-- Assinatura Padrão / Em Branco --</option>
                          {availableSignatures.filter(s => s.is_responsible_engineer == 1 || s.is_responsible_engineer === true || s.is_responsible_engineer === '1').map((sig, idx) => (
                              <option key={idx} value={sig.id}>
                                  {sig.signature_name} - {sig.signature_role}
                              </option>
                          ))}
                      </select>
                  </div>
              </div>

          </div>
        )}

        {/* CSS DE IMPRESSÃO E ZOOM DE TELA COM TRATAMENTO MOBILE */}
        <style>{`
          @media screen {
            .laudo-container-outer {
                background-color: #ffffff !important;
                padding: 0 !important;
                display: block !important; /* FIX: Remove o flex que causava o corte lateral na rolagem */
                overflow-x: auto !important;
                -webkit-overflow-scrolling: touch !important; 
            }
            .laudo-container {
                width: 100% !important;
                min-width: 1000px !important; /* IMPEDE QUE A TABELA SEJA ESMAGADA NO MOBILE */
                max-width: 100% !important;
                box-shadow: none !important;
                margin: 0 auto !important; /* FIX: Centraliza quando há espaço, mas não corta */
                transform: none !important;
            }
            table {
                font-size: 16px !important; /* Zoom no texto para leitura na tela */
            }
            td {
                padding: 6px 4px !important; /* Zoom no espaçamento das células */
            }
            .print-input {
                font-size: 14px !important; /* Zoom nos inputs */
            }
          }
          @media print {
            @page { size: A4 portrait; margin: 3mm; }
            .no-print { display: none !important; }
            html, body { height: auto !important; min-height: 100%; margin: 0 !important; padding: 0 !important; background-color: white !important; -webkit-print-color-adjust: exact; overflow: visible !important; }
            .print-input { background-color: transparent !important; }
            
            .laudo-container-outer { 
                background-color: white !important; 
                padding: 0 !important; 
                display: block !important; 
                width: 100% !important;
                overflow: visible !important;
            }
            
            .laudo-container { 
                width: 89.2% !important; 
                min-width: 0 !important; /* Remove o limite no PDF */
                margin: 0 !important; 
                padding: 0 !important; 
                box-shadow: none !important;
                overflow: visible !important; 
                transform: scale(1.12) !important; 
                transform-origin: top left !important; 
                margin-bottom: 0 !important;
            }
            
            table { width: 100% !important; border-collapse: collapse; font-size: 8.8pt !important; line-height: 1.0 !important; }
            td { padding: 0px 2px !important; height: auto !important; }
            img { max-width: 100% !important; height: auto !important; }
            textarea { resize: none !important; overflow: hidden !important; }
            .page-break { page-break-before: always; }
            .photos-block { page-break-inside: avoid; }
            select {
              appearance: none;
              -webkit-appearance: none;
              -moz-appearance: none;
              border: none;
              background: transparent;
            }
            ::-webkit-scrollbar { display: none; }
          }
          table { font-family: "Calibri", sans-serif; font-size: 11px; border-collapse: collapse; table-layout: fixed; width: 100%; }
          td { padding: 2px; vertical-align: middle; }
        `}</style>

        <table cellSpacing="0" border="0">
          <colgroup>
              <col style={{ width: '9.8%' }} /><col style={{ width: '9.8%' }} /><col style={{ width: '9.8%' }} /><col style={{ width: '9.8%' }} /><col style={{ width: '9.8%' }} />
              <col style={{ width: '2.0%' }} />
              <col style={{ width: '9.8%' }} /><col style={{ width: '9.8%' }} /><col style={{ width: '9.8%' }} /><col style={{ width: '9.8%' }} /><col style={{ width: '9.8%' }} />
          </colgroup>
          <tbody>
            <tr><td style={{ borderBottom: '2px solid #000000' }} colSpan={11} height="10" bgcolor="#FFFFFF"></td></tr>
            
            {/* LOGO E DADOS EMPRESA (DINÂMICOS VIA SETTINGS) */}
            <tr>
              <td style={{ borderTop: '2px solid #000000', borderLeft: '2px solid #000000', borderRight: '2px solid #000000', padding: '5px' }} colSpan={11} height="60" align="right" valign="middle">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '100%' }}>
                    {/* LOGO DINÂMICA SALVA NA PASTA LAYOUT_IMAGES */}
                    {reportLayout.laudo_logo_path ? (
                        <img 
                          src={getDirectImageUrl(`/api/uploads/layout_images/${reportLayout.laudo_logo_path}`)} 
                          alt="Logo Empresa" 
                          style={{ maxWidth: '200px', maxHeight: '55px', objectFit: 'contain', alignSelf: 'center' }} 
                        />
                    ) : (
                        <img src={logoLaudoDefault} alt="Logo Padrão" style={{ maxWidth: '200px', maxHeight: '55px', objectFit: 'contain', alignSelf: 'center' }} />
                    )}
                    <div style={{ textAlign: 'right', fontSize: '9px', color: '#000', lineHeight: '1.1' }}>
                      {/* DADOS DINÂMICOS VINDOS DE LAYOUT LAUDOS */}
                      <b>{reportLayout.laudo_empresa_nome || 'RazãoSocial'}</b><br />
                      CNPJ: {reportLayout.laudo_empresa_cnpj || 'CNPJ'}   {t.state_reg} IE: {reportLayout.laudo_empresa_ie || 'IE'} <br />
                      {reportLayout.laudo_empresa_endereco || 'Endereço'}<br />
                      {t.phone_label} {reportLayout.laudo_empresa_telefone || 'Telefone'}   {t.email_label} {reportLayout.laudo_empresa_email || 'Email'}
                    </div>
                </div>
              </td>
            </tr>

            {/* TÍTULO */}
            <tr>
              <td style={{ borderTop: '3px solid #000000', borderLeft: '3px solid #000000', borderRight: '3px solid #000000' }} colSpan={11} height="25" align="center" valign="middle" bgcolor="#000000">
                <b><font size="3" color="#FFFFFF">{t.title}</font></b>
              </td>
            </tr>

            {/* REFERÊNCIA E DATA */}
            <tr>
              <td style={{ borderTop: '2px solid #000000', borderBottom: '3px solid #000000', borderLeft: '2px solid #000000', borderRight: '2px solid #000000' }} rowSpan={2} height="30" align="center" valign="middle"><b>{t.ref}</b></td>
              <td style={{ borderTop: '2px solid #000000', borderBottom: '3px solid #000000', borderLeft: '2px solid #000000', borderRight: '2px solid #000000' }} colSpan={2} rowSpan={2} align="center" valign="middle"><InputCell field="referencia" {...commonProps} /></td>
              <td style={{ borderTop: '2px solid #000000', borderBottom: '3px solid #000000', borderLeft: '2px solid #000000', borderRight: '2px solid #000000' }} colSpan={4} rowSpan={2} align="center" valign="middle"><b><font size="4">{t.cat}</font></b></td>
              <td style={{ borderTop: '2px solid #000000', borderBottom: '3px solid #000000', borderLeft: '2px solid #000000', borderRight: 'none' }} colSpan={2} rowSpan={2} align="center" valign="middle"><b>{t.emission}</b></td>
              <td style={{ borderTop: '2px solid #000000', borderBottom: '3px solid #000000', borderLeft: 'none', borderRight: '2px solid #000000' }} colSpan={2} rowSpan={2} align="center" valign="middle"><InputCell field="data_emissao" type="date" {...commonProps} onChange={handleChange} /></td>
            </tr>
            
            <tr><td colSpan={11} height="5"></td></tr>

            {/* CABEÇALHO NORMAS */}
            <tr>
              <td style={{ border: '2px solid #000000' }} colSpan={3} height="20" align="left" valign="bottom" bgcolor="#BFBFBF"><b>{t.h_test}</b></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2} align="center" valign="bottom" bgcolor="#BFBFBF"><b>{t.h_norm}</b></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2} align="center" valign="bottom" bgcolor="#BFBFBF"><b>{t.h_total}</b></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2} align="center" valign="bottom" bgcolor="#BFBFBF"><b>{t.h_approved}</b></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2} align="center" valign="bottom" bgcolor="#BFBFBF"><b>{t.h_repro}</b></td>
            </tr>
            {/* LINHAS NORMAS */}
            <tr>
              <td style={{ border: '2px solid #000000' }} colSpan={3} height="18" align="left" valign="middle">{t.item_cesta}</td>
              <td style={{ border: '2px solid #000000' }} colSpan={2} align="center" valign="middle">
                  <InputCell field="texto_norma_cesta" placeholder="ABNT NBR 16.092" {...commonProps} valueOverride={getFormattedNorm(specialData?.defaultAnsi || (SPECIAL_ITEMS_TEMPLATES['CESTO AÉREO']?.[lang]?.defaultAnsi))} />
              </td>
              <td style={{ border: '2px solid #000000' }} colSpan={2}><InputCell field="cesta_total" {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2}><InputCell field="cesta_aprovado" {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2}><InputCell field="cesta_reprovado" {...commonProps} /></td>
            </tr>
            <tr>
              <td style={{ border: '2px solid #000000' }} colSpan={3} height="18" align="left" valign="middle">{t.item_liner}</td>
              <td style={{ border: '2px solid #000000' }} colSpan={2} align="center" valign="middle">
                  <InputCell field="texto_norma_liner" placeholder="ABNT NBR 16.092" {...commonProps} valueOverride={getFormattedNorm(specialData?.defaultAnsi || (SPECIAL_ITEMS_TEMPLATES['CESTO AÉREO']?.[lang]?.defaultAnsi))} />
              </td>
              <td style={{ border: '2px solid #000000' }} colSpan={2}><InputCell field="liner_total" {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2}><InputCell field="liner_aprovado" {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2}><InputCell field="liner_reprovado" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderBottom: '2px solid black'}} colSpan={11} height="5"></td></tr>

            {/* 1 - OBJETO / ESCOPO */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_1}</b></td></tr>
            
            {/* LAYOUT HÍBRIDO (FIXO/DINÂMICO) */}
            <tr>
              <td style={{ border: '2px solid #000000' }} colSpan={11} height="25" align="center" valign="middle" bgcolor="#ffffff">
                  <div style={{ display: 'flex', align: "center", alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', fontFamily: 'Calibri, Arial, sans-serif', fontSize: '10pt', fontWeight: 'bold', gap: '4px' }}>
                      {specialData ? (
                          <span style={{ color: '#000000', fontSize: '10pt', fontWeight: 'bold', textAlign: 'center' }}>
                              {scopeText}
                          </span>
                      ) : (
                          <>
                               <div style={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <InputCell field="titulo_ensaio_nome" placeholder="ENSAIO EM..." {...commonProps} valueOverride={formatSentenceCase(getTranslatedItem(safeData.titulo_ensaio_nome))} style={{ backgroundColor: 'transparent', color: '#000000', fontSize: '10pt', textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase' }} />
                              </div>
                              <div style={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <InputCell field="titulo_ensaio_norma" placeholder="NORMA..." {...commonProps} valueOverride={getFormattedNorm()} style={{ backgroundColor: 'transparent', color: '#000000', fontSize: '9pt', textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase' }} />
                              </div>
                          </>
                      )}
                  </div>
              </td>
            </tr>
            
            <tr>
              <td style={{ border: '2px solid #000000' }} colSpan={3} height="20" align="center" valign="middle"><CheckCell field="escopo_lanca" label={t.lanca_sup} {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={5} align="center" valign="middle"><CheckCell field="escopo_chassi" label={t.iso_chassi} {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={3} align="center" valign="middle"><CheckCell field="escopo_liner" label={t.liner} {...commonProps} /></td>
            </tr>
            <tr><td style={{borderBottom: '2px solid black'}} colSpan={11} height="5"></td></tr>

            {/* 2 - DADOS DO CLIENTE */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_2}</b></td></tr>
            <tr>
              <td style={{ border: '2px solid #000000' }} colSpan={4} height="20" align="center" valign="middle"><b>{t.client}</b></td>
              <td style={{ border: '2px solid #000000' }} colSpan={3} align="center" valign="middle"><b>{t.cnpj}</b></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2} align="center" valign="middle"><b>{t.manager}</b></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2} align="center" valign="middle"><b>{t.phone}</b></td>
            </tr>
            <tr>
              <td style={{ border: '2px solid #000000' }} colSpan={4} height="20"><InputCell field="cliente_nome" {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={3}><InputCell field="cliente_cnpj" {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2}><InputCell field="cliente_gestor" {...commonProps} /></td>
              <td style={{ border: '2px solid #000000' }} colSpan={2}><InputCell field="cliente_telefone" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderBottom: '2px solid black'}} colSpan={11} height="5"></td></tr>

            {/* 3 - ÁREA ATENDIDA */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_3}</b></td></tr>
            <tr>
              <td style={{ border: '2px solid #000000' }} height="20" align="center" valign="middle"><b>{t.local}</b></td>
              <td style={{ border: '2px solid #000000' }} colSpan={10} align="left" valign="middle"><InputCell field="area_atendida" align="left" style={{paddingLeft: '5px'}} {...commonProps} /></td>
            </tr>

            {/* ENSAIO CENTRAL - DUAS LINHAS */}
            <tr><td colSpan={11} height="5" style={{borderBottom: '2px solid black'}}></td></tr>
            <tr>
              <td style={{ border: '2px solid #000000' }} colSpan={11} height="30" align="center" valign="middle" bgcolor="#A6A6A6">
                  <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center' }}>
                      {specialData ? (
                          <>
                              <div style={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <span style={{ color: '#000000', fontSize: '10pt', fontWeight: 'bold', textTransform: 'uppercase' }}>
                                      {specialData.headerTitle}
                                  </span>
                              </div>
                              <div style={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <span style={{ color: '#000000', fontSize: '9pt', fontWeight: 'bold', textTransform: 'uppercase' }}>
                                      {specialData.headerNorm}
                                  </span>
                              </div>
                          </>
                      ) : (
                          <>
                               <div style={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <InputCell field="titulo_ensaio_nome" placeholder="ENSAIO EM..." {...commonProps} valueOverride={formatSentenceCase(getTranslatedItem(safeData.titulo_ensaio_nome))} style={{ backgroundColor: 'transparent', color: '#000000', fontSize: '10pt', textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase' }} />
                              </div>
                              <div style={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <InputCell field="titulo_ensaio_norma" placeholder="NORMA..." {...commonProps} valueOverride={getFormattedNorm()} style={{ backgroundColor: 'transparent', color: '#000000', fontSize: '9pt', textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase' }} />
                              </div>
                          </>
                      )}
                  </div>
              </td>
            </tr>
            <tr><td style={{borderBottom: '2px solid black'}} colSpan={11} height="5"></td></tr>

            {/* 4 - VEICULO */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_4}</b></td></tr>
            <tr style={{textAlign: 'center', fontWeight: 'bold'}}>
               <td style={{border:'2px solid #000'}} colSpan={2}>{t.brand}</td><td style={{border:'2px solid #000'}} colSpan={1}>{t.model}</td><td style={{border:'2px solid #000'}} colSpan={4}>{t.chassi}</td><td style={{border:'2px solid #000'}} colSpan={1}>{t.plate}</td><td style={{border:'2px solid #000'}} colSpan={1}>{t.odo}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.hori}</td>
            </tr>
            <tr>
               <td style={{border:'2px solid #000'}} colSpan={2} height="20"><InputCell field="equipamento_marca" {...commonProps} /></td>
               <td style={{border:'2px solid #000'}} colSpan={1}><InputCell field="equipamento_modelo" {...commonProps} /></td>
               <td style={{border:'2px solid #000'}} colSpan={4}><InputCell field="equipamento_serie" {...commonProps} /></td>
               <td style={{border:'2px solid #000'}} colSpan={1}><InputCell field="equipamento_placa" {...commonProps} /></td>
               <td style={{border:'2px solid #000'}} colSpan={1}><InputCell field="equipamento_hodometro" {...commonProps} /></td>
               <td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="equipamento_horimetro" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderBottom: '2px solid black'}} colSpan={11} height="5"></td></tr>

            {/* 5 - LANÇA ISOLADA */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_5}</b></td></tr>
            <tr style={{textAlign: 'center', fontWeight: 'bold'}}>
                <td style={{border:'2px solid #000'}} colSpan={2}>{t.brand}</td><td style={{border:'2px solid #000'}} colSpan={4}>{t.model}</td><td style={{border:'2px solid #000'}} colSpan={3}>{t.serial}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.baskets}</td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000'}} colSpan={2} height="20"><InputCell field="lanca_marca" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={4}><InputCell field="lanca_modelo" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={3}><InputCell field="lanca_serie" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="lanca_cestos" {...commonProps} /></td>
            </tr>
            <tr style={{textAlign: 'center', fontWeight: 'bold'}}>
                <td style={{border:'2px solid #000'}} colSpan={2}>{t.capacity}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.category}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.class}</td><td style={{border:'2px solid #000'}} colSpan={3}>{t.stab}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.type_test}</td>
            </tr>
             <tr>
                <td style={{border:'2px solid #000'}} colSpan={2} height="20"><InputCell field="lanca_capacidade" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="tecnico_categoria" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="tecnico_classe_tensao" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={3}><InputCell field="lanca_estabilizador" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="lanca_tipo_ensaio" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderBottom: '2px solid black'}} colSpan={11} height="5"></td></tr>

            {/* 6 - INSTRUMENTAÇÃO */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_6}</b></td></tr>
            <tr style={{textAlign: 'center', fontWeight: 'bold'}}>
                <td style={{border:'2px solid #000', borderRight: 'none'}} colSpan={4}>{t.mod_serial}</td><td style={{border:'2px solid #000', borderLeft: 'none'}} colSpan={4}>{t.cert}</td><td style={{border:'2px solid #000'}} colSpan={3}>{t.validity}</td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000'}} colSpan={4} height="20"><InputCell field="padrao_modelo_serie" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={4}><InputCell field="padrao_certificado" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={3}><InputCell field="padrao_validade" type="date" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderBottom: '2px solid black'}} colSpan={11} height="5"></td></tr>

            {/* 7 - DADOS DO ENSAIO (LANÇA) */}
             <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_7}</b></td></tr>
            <tr style={{textAlign: 'center', fontWeight: 'bold'}}>
                <td style={{border:'2px solid #000'}} colSpan={3}>{t.city}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.date}</td><td style={{border:'2px solid #000'}} colSpan={3}>{t.temp}</td><td style={{border:'2px solid #000'}} colSpan={3}>{t.lot}</td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000'}} colSpan={3} height="20"><InputCell field="ensaio_cidade" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="ensaio_data" type="date" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={3}><InputCell field="amb_temperatura" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={3}><InputCell field="ensaio_lote" {...commonProps} /></td>
            </tr>
            <tr style={{textAlign: 'center', fontWeight: 'bold'}}>
                <td style={{border:'2px solid #000'}} colSpan={3}>{t.h_start}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.h_end}</td><td style={{border:'2px solid #000'}} colSpan={3}>{t.humid}</td><td style={{border:'2px solid #000'}} colSpan={3}>{t.trace}</td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000'}} colSpan={3} height="20"><InputCell field="hora_inicio" type="time" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="hora_termino" type="time" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={3}><InputCell field="amb_umidade" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}} colSpan={3}><InputCell field="codigo_rastreabilidade" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderBottom: '2px solid black'}} colSpan={11} height="5"></td></tr>

            {/* 8 - VALORES DE CORRENTE DE FUGA MENSURADOS */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="25" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_8}</b></td></tr>
            <tr><td style={{borderTop:'2px solid #000', borderBottom:'2px solid #000', borderLeft:'2px solid #000', borderRight:'2px solid #000'}} colSpan={11} height="5"></td></tr>
            
            {/* QUALIFICAÇÃO */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="center" valign="middle" bgcolor="#A6A6A6"><CheckCell field="tipo_ensaio_qualificacao" label={t.qualif_test} {...commonProps} /></td></tr>
            <tr>
                <td style={{border:'2px solid #000'}} colSpan={5} height="20" align="center" bgcolor="#A6A6A6"><CheckCell field="qualif_lanca_chk" label={t.lanca_sup} {...commonProps} /></td>
                <td style={{border:'none', borderLeft: 'none', borderRight: 'none'}} rowSpan={4}></td> 
                <td style={{border:'2px solid #000'}} colSpan={5} align="center" bgcolor="#A6A6A6"><CheckCell field="qualif_chassi_chk" label={t.iso_chassi} {...commonProps} /></td>
            </tr>
            <tr style={{fontSize: '9px', fontWeight: 'bold', textAlign: 'center'}}>
                <td style={{border:'2px solid #000'}} height="18">{t.col_voltage}</td><td style={{border:'2px solid #000'}}>{t.col_leak}</td><td style={{border:'2px solid #000'}}>{t.col_measure}</td><td style={{border:'2px solid #000'}}>{t.col_time}</td><td style={{border:'2px solid #000'}}>{t.col_result}</td>
                <td style={{border:'2px solid #000'}}>{t.col_voltage}</td><td style={{border:'2px solid #000'}}>{t.col_leak}</td><td style={{border:'2px solid #000'}}>{t.col_measure}</td><td style={{border:'2px solid #000'}}>{t.col_time}</td><td style={{border:'2px solid #000'}}>{t.col_result}</td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000'}} height="25"><InputCell field="lanca_qualif_tensao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="lanca_qualif_corrente" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="lanca_qualif_medicao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="lanca_qualif_tempo" {...commonProps} /></td><td style={{border:'2px solid #000'}}><ResultSelectCell field="lanca_qualif_resultado" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}}><InputCell field="chassi_qualif_tensao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="chassi_qualif_corrente" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="chassi_qualif_medicao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="chassi_qualif_tempo" {...commonProps} /></td><td style={{border:'2px solid #000'}}><ResultSelectCell field="chassi_qualif_resultado" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderLeft:'2px solid #000'}} colSpan={11} height="5"></td></tr>

            {/* PERIÓDICO */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="center" valign="middle" bgcolor="#A6A6A6"><CheckCell field="tipo_ensaio_periodico" label={t.period_test} {...commonProps} /></td></tr>
            <tr>
                <td style={{border:'2px solid #000'}} colSpan={5} height="20" align="center" bgcolor="#A6A6A6"><CheckCell field="period_lanca_chk" label={t.lanca_sup} {...commonProps} /></td>
                <td style={{border:'none', borderLeft: 'none', borderRight: 'none'}} rowSpan={4}></td>
                <td style={{border:'2px solid #000'}} colSpan={5} align="center" bgcolor="#A6A6A6"><CheckCell field="period_chassi_chk" label={t.iso_chassi} {...commonProps} /></td>
            </tr>
            <tr style={{fontSize: '9px', fontWeight: 'bold', textAlign: 'center'}}>
                <td style={{border:'2px solid #000'}} height="18">{t.col_voltage}</td><td style={{border:'2px solid #000'}}>{t.col_leak}</td><td style={{border:'2px solid #000'}}>{t.col_measure}</td><td style={{border:'2px solid #000'}}>{t.col_time}</td><td style={{border:'2px solid #000'}}>{t.col_result}</td>
                <td style={{border:'2px solid #000'}}>{t.col_voltage}</td><td style={{border:'2px solid #000'}}>{t.col_leak}</td><td style={{border:'2px solid #000'}}>{t.col_measure}</td><td style={{border:'2px solid #000'}}>{t.col_time}</td><td style={{border:'2px solid #000'}}>{t.col_result}</td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000'}} height="25"><InputCell field="lanca_period_tensao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="lanca_period_corrente" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="lanca_period_medicao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="lanca_period_tempo" {...commonProps} /></td><td style={{border:'2px solid #000'}}><ResultSelectCell field="lanca_period_resultado" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}}><InputCell field="chassi_period_tensao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="chassi_period_corrente" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="chassi_period_medicao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="chassi_period_tempo" {...commonProps} /></td><td style={{border:'2px solid #000'}}><ResultSelectCell field="chassi_period_resultado" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderLeft:'2px solid #000'}} colSpan={11} height="5"></td></tr>

            {/* LINER */}
             <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="center" valign="middle" bgcolor="#A6A6A6"><CheckCell field="ensaio_liner_chk" label={t.liner_test_title} {...commonProps} /></td></tr>
            <tr>
                <td style={{border:'2px solid #000'}} colSpan={5} height="20" align="center" bgcolor="#A6A6A6"><CheckCell field="liner_qualif_chk" label={t.qualif} {...commonProps} /></td>
                <td style={{border:'none', borderLeft: 'none', borderRight: 'none'}} rowSpan={4}></td>
                <td style={{border:'2px solid #000'}} colSpan={5} align="center" bgcolor="#A6A6A6"><CheckCell field="liner_period_chk" label={t.period} {...commonProps} /></td>
            </tr>
            <tr style={{fontSize: '9px', fontWeight: 'bold', textAlign: 'center'}}>
                <td style={{border:'2px solid #000'}} height="18">{t.col_applied}</td><td style={{border:'2px solid #000'}}>{t.col_voltage}</td><td style={{border:'2px solid #000'}}>{t.col_time}</td><td style={{border:'2px solid #000'}}>{t.col_method}</td><td style={{border:'2px solid #000'}}>{t.col_result}</td>
                <td style={{border:'2px solid #000'}}>{t.col_applied}</td><td style={{border:'2px solid #000'}}>{t.col_voltage}</td><td style={{border:'2px solid #000'}}>{t.col_time}</td><td style={{border:'2px solid #000'}}>{t.col_method}</td><td style={{border:'2px solid #000'}}>{t.col_result}</td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000'}} height="55"><InputCell field="liner_qualif_aplicado" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="liner_qualif_tensao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="liner_qualif_tempo" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}}><TextAreaCell field="liner_qualif_metodo" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}}><ResultSelectCell field="liner_qualif_resultado" {...commonProps} /></td>
                
                <td style={{border:'2px solid #000'}}><InputCell field="liner_period_aplicado" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="liner_period_tensao" {...commonProps} /></td><td style={{border:'2px solid #000'}}><InputCell field="liner_period_tempo" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}}><TextAreaCell field="liner_period_metodo" {...commonProps} /></td>
                <td style={{border:'2px solid #000'}}><ResultSelectCell field="liner_period_res" {...commonProps} /></td>
            </tr>
            <tr><td colSpan={11} height="5"></td></tr>

            {/* OBSERVAÇÕES */}
            <tr>
                <td style={{ border: '2px solid #000000' }} colSpan={2} rowSpan={2} height="30" align="center" valign="middle"><b>{t.obs}</b></td>
                <td style={{ border: '2px solid #000000' }} colSpan={9} rowSpan={2} align="left" valign="middle">
                    <textarea 
                        value={safeData['obs_relevantes'] || ''}
                        onChange={(e) => !readOnly && handleChange('obs_relevantes', e.target.value)}
                        style={{width: '100%', height: '100%', border: 'none', resize: 'none', fontFamily: 'inherit', boxSizing: 'border-box'}}
                    />
                </td>
            </tr>
            <tr></tr>

            <tr><td colSpan={11} height="5"></td></tr>

            {/* 9 - DADOS ENSAIO LINER (RODAPÉ) */}
            <tr><td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6"><b>{t.sec_9}</b></td></tr>
            <tr style={{textAlign: 'center', fontWeight: 'bold'}}>
                <td style={{border:'2px solid #000'}} colSpan={4}>{t.v_plate}</td><td style={{border:'2px solid #000'}} colSpan={3}>{t.v_chassi}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.lot}</td><td style={{border:'2px solid #000'}} colSpan={2}>{t.trace}</td>
            </tr>
             <tr>
                <td style={{border:'2px solid #000'}} colSpan={4} height="20"><InputCell field="liner_placa" {...commonProps} /></td><td style={{border:'2px solid #000'}} colSpan={3}><InputCell field="liner_chassi" {...commonProps} /></td><td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="liner_lote" {...commonProps} /></td><td style={{border:'2px solid #000'}} colSpan={2}><InputCell field="liner_rastreio" {...commonProps} /></td>
            </tr>
            <tr><td style={{borderLeft:'2px solid #000', borderRight:'2px solid #000'}} colSpan={11} height="5"></td></tr>

            {/* 10 - RESPONSABILIDADE E ASSINATURAS */}
            <tr>
                <td style={{ border: '2px solid #000000' }} colSpan={11} height="20" align="left" valign="middle" bgcolor="#A6A6A6">
                    <b>{t.sec_10_resp}</b>
                </td>
            </tr>
            <tr>
                <td style={{ border: '2px solid #000000' }} colSpan={5} height="18" align="center" valign="middle" bgcolor="#EAEAEA">
                    <b>{t.emission_sign}</b>
                </td>
                <td style={{ border: '2px solid #000000' }} colSpan={6} align="center" valign="middle" bgcolor="#EAEAEA">
                    <b>{t.approval_sign}</b>
                </td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000', position: 'relative'}} colSpan={5} height="90" align="center" valign="middle">
                    {finalTechImagem && (
                        <img 
                            src={finalTechImagem} 
                            alt="Assinatura Técnico" 
                            crossOrigin="anonymous" // ADICIONADO PARA CORRIGIR IMPRESSÃO
                            style={{ display: 'block', margin: '0 auto 5px auto', maxWidth: '90%', maxHeight: '50px', objectFit: 'contain' }} 
                        />
                    )}
                    <b>{finalTechNome || '_________________________________________'}</b><br />
                    <span style={{fontSize: '10px', color: '#333'}}>{translateRole(finalTechFuncao)}</span><br />
                    <span style={{fontSize: '10px', color: '#333'}}>{finalTechRegistro || t.reg_default}</span>
                </td>
                <td style={{border:'2px solid #000', position: 'relative'}} colSpan={6} align="center" valign="middle">
                    {/* ASSINATURA DO ENGENHEIRO DINÂMICA (APROVAÇÃO) */}
                    {finalEngImagem ? (
                        <img 
                            src={finalEngImagem} 
                            alt="Assinatura Engenheiro" 
                            crossOrigin="anonymous" // ADICIONADO PARA CORRIGIR IMPRESSÃO
                            style={{ display: 'block', margin: '0 auto 5px auto', maxWidth: '90%', maxHeight: '50px', objectFit: 'contain' }} 
                        />
                    ) : (
                        <div style={{ height: '55px' }}></div>
                    )}
                    <b>{finalEngNome || '_________________________________________'}</b><br />
                    <span style={{fontSize: '10px', color: '#333'}}>{finalEngFuncao || t.engineer_title}</span><br />
                    <span style={{fontSize: '10px', color: '#333'}}>{finalEngRegistro || 'CREA nº 00000000'}</span>
                </td>
            </tr>
            
            <tr><td colSpan={11} height="5"></td></tr>

            {/* 11 - ATENÇÃO / VALIDADE */}
            <tr>
                <td style={{border:'2px solid #000'}} colSpan={9} height="18" align="left" bgcolor="#A6A6A6"><b>{t.sec_10.replace('10', '11')}</b></td>
                <td style={{border:'2px solid #000'}} colSpan={2} align="center" bgcolor="#A6A6A6"><b>{t.valid_until}</b></td>
            </tr>
            <tr>
                <td style={{border:'2px solid #000', fontSize:'10px'}} colSpan={9} height="30" align="center" valign="middle">
                    {t.warning_msg}
                </td>
                <td style={{border:'2px solid #000'}} colSpan={2} align="center" valign="middle">
                    <b><InputCell field="data_validade" type="date" {...commonProps} /></b>
                </td>
            </tr>

            </tbody>
        </table>

        {/* --- SEÇÃO NOVA: FOTOS DO LAUDO (LAUDO FOTOGRÁFICO) --- */}
        {validPhotos && validPhotos.length > 0 && (
            <div className="page-break" style={{ marginTop: '20px' }}>
                <div style={{ textAlign: 'center', marginBottom: '15px', borderBottom: '2px solid black', paddingBottom: '5px' }}>
                    <h3 style={{ fontSize: '14pt', fontWeight: 'bold', fontFamily: 'Calibri, Arial, sans-serif' }}>
                        {PHOTO_TITLES[lang]} - OS: {safeData.referencia || safeData.pedido || 'N/A'}
                    </h3>
                    
                    {/* --- NOVA LINHA COM PLACA, CHASSI E SÉRIE --- */}
                    {(safeData.equipamento_placa || safeData.equipamento_serie || safeData.lanca_serie) && (
                        <div style={{ fontSize: '12pt', fontWeight: 'bold', fontFamily: 'Calibri, Arial, sans-serif', marginTop: '5px' }}>
                            {safeData.equipamento_placa && <span style={{ marginRight: '15px' }}>PLACA: {safeData.equipamento_placa}</span>}
                            {safeData.equipamento_serie && <span style={{ marginRight: '15px' }}>CHASSI: {safeData.equipamento_serie}</span>}
                            {safeData.lanca_serie && <span>SÉRIE: {safeData.lanca_serie}</span>}
                        </div>
                    )}
                    
                </div>
                
                <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: '1fr 1fr', 
                    gap: '5px', /* REDUZIDO GAP PARA JUNTAR MAIS AS FOTOS */
                    pageBreakInside: 'avoid'
                }}>
                    {validPhotos.map((url, index) => (
                        <div key={index} style={{ 
                            display: 'flex', 
                            flexDirection: 'column',
                            alignItems: 'flex-start' 
                        }}>
                            <span style={{ fontSize: '9pt', fontWeight: 'bold', marginBottom: '2px', fontFamily: 'Calibri', color: '#505050' }}>
                                Foto {index + 1}
                            </span>
                            <div style={{ 
                                border: '1px solid #c8c8c8', 
                                padding: '1px',
                                width: '100%',
                                height: '200px', // AUMENTADO PARA PREENCHER MELHOR A PÁGINA (era 150px)
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                overflow: 'hidden'
                            }}>
                                <img 
                                    src={getDirectImageUrl(url)} 
                                    alt={`Foto ${index + 1}`} 
                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )}
        </div>
    </div>
  );
};

export default LaudoTensaoAplicada;